import React from "react";
import { EXPERIENCE, NOTABLE, ABOUT_IMG, BRAND } from "../../data";
import { Reveal } from "./Reveal";
import { motion } from "framer-motion";

export const Experience = () => (
  <section
    id="experience"
    data-testid="experience-section"
    className="relative py-24 sm:py-32 bg-[#050505]"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        {/* Left: about + notable */}
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-[#E879F9] font-bold mb-4">
              03 — The Story
            </p>
            <div className="relative overflow-hidden rounded-2xl border border-white/10 mb-8">
              <img src={ABOUT_IMG} alt="Backstage" className="w-full h-64 object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] to-transparent" />
              <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-[#b533ff]/25 blur-[90px]" />
            </div>
            <p className="text-base sm:text-lg text-gray-300 font-light leading-relaxed">
              Touring and live-events professional with deep experience across festival
              operations, tour management, artist liaison, hospitality, ticketing and
              merchandise — from large-scale festivals to international touring.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-10">
              <p className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-4">
                Toured & worked with
              </p>
              <div className="flex flex-wrap gap-2.5">
                {NOTABLE.map((n) => (
                  <span
                    key={n}
                    data-testid={`notable-${n}`}
                    className="text-sm px-4 py-2 rounded-full border border-white/15 text-gray-200 hover:border-[#b533ff] hover:text-white transition-colors duration-300"
                  >
                    {n}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        {/* Right: experience list */}
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-5xl leading-[0.95] mb-10">
              Track <span className="text-[#b533ff]">record.</span>
            </h2>
          </Reveal>
          <div className="divide-y divide-white/10 border-t border-white/10">
            {EXPERIENCE.map((e, i) => (
              <Reveal key={e.org} delay={i * 0.04}>
                <motion.div
                  data-testid={`experience-${i}`}
                  whileHover={{ x: 8 }}
                  transition={{ duration: 0.3 }}
                  className="group py-6 flex items-start justify-between gap-6"
                >
                  <div>
                    <h3 className="font-display font-bold uppercase text-base sm:text-xl text-white group-hover:text-[#b533ff] transition-colors duration-300">
                      {e.org}
                    </h3>
                    <p className="text-sm text-gray-400 mt-1 font-light">{e.note}</p>
                  </div>
                  <span className="text-right text-xs sm:text-sm text-gray-300 uppercase tracking-wide shrink-0 max-w-[45%]">
                    {e.role}
                  </span>
                </motion.div>
              </Reveal>
            ))}
          </div>
          <p className="mt-8 text-sm text-gray-500 font-light">
            Based in {BRAND.location} · Native Catalan & Spanish · Proficient English
          </p>
        </div>
      </div>
    </div>
  </section>
);
